//export const API_URL = 'https://api-explora-producciones.us-west-2.elasticbeanstalk.com/channel';
export let SUPPORTS_WEBP = false;

export const supportsWebP = async () => {
  if (!window.createImageBitmap) {
    return false;
  }

  const webpData = 'data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA=';
  const blob = await fetch(webpData).then((r) => r.blob());

  const supports = await createImageBitmap(blob);

  if (supports) {
    SUPPORTS_WEBP = true;
  }
};
